<template>
  <div class="list-page">
    <crumbs title="专家信息管理" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="22">
          <el-input
            v-model="queryCondition.keyWord"
            clearable
            placeholder="专家姓名"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar">
      <el-button type="success" icon="el-icon-circle-plus" @click="handleAdd"
        >添加
      </el-button>
      <el-button type="warning" icon="el-icon-delete" @click="handleBatchDelete"
        >删除</el-button
      >
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column prop="name" label="专家姓名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="专家图片" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 200px; height: 100px"
              :src="scope.row.imgUrl"
              fit="contain"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述"> </el-table-column>
        <el-table-column label="发布时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.createTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.createTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
        <el-table-column label="位置调整" width="220" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              icon="el-icon-arrow-up"
              @click="handleUpDown('expertSNUp', scope.row)"
            ></el-button>
            <el-button
              size="mini"
              icon="el-icon-arrow-down"
              @click="handleUpDown('expertSNDown', scope.row)"
            ></el-button>
            <el-button
              size="mini"
              type="success"
              @click="handleModSN(scope.row)"
              >输入序号</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="handleLook(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <add-expert
      v-if="expertDialog"
      :dataId="expertId"
      @close="expertDialog = false"
      @complete="completeAdd"
    />
    <add-expert-sn
      v-if="SNDialog"
      :dataSN="expertSN"
      :maxSN="total"
      @close="SNDialog = false"
      @complete="completeModSN"
    />
  </div>
</template>

<script>
export default {
  name: "expertMessageList",
  data() {
    return {
      //查询条件
      queryCondition: {
        keyWord: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: [],
      // 添加弹框
      expertId: "",
      expertDialog: false,
      expertSN: "",
      SNDialog: false
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    //出来参数
    processParams() {
      return this.queryCondition;
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("expert", "getExpertList", this.processParams()).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.queryList = res.dataList;
      });
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    // 点击添加
    handleAdd() {
      this.expertId = "";
      this.expertDialog = true;
    },
    // 点击调整位置
    handleUpDown(api, row) {
      const { id } = row;
      this.$api("expert", api, { id }).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击修改序号
    handleModSN(row) {
      const { order } = row;
      this.expertSN = order;
      this.SNDialog = true;
    },
    //点击编辑
    handleLook(row) {
      const { id } = row;
      this.expertId = id;
      this.expertDialog = true;
    },
    //删除
    //点击批量删除
    handleBatchDelete() {
      const idList = this.multipleSelection.map((item) => item.id);
      if (idList.length) {
        this.$confirm("此操作将批量删除所选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loadDeleteData(idList);
          })
          .catch(() => {});
      }
    },
    //点击一条删除
    handleDelete(row) {
      this.$confirm("此操作将删除当前所选中的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadDeleteData([row.id]);
        })
        .catch(() => {});
    },
    loadDeleteData(idList) {
      this.$api("expert", "batchExpertDelete", idList).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    },
    // 完成添加
    completeAdd() {
      this.expertDialog = false;
      this.loadList();
    },
    completeModSN() {
      this.SNDialog = false;
      this.loadList();
    }
  }
};
</script>

<style></style>
